import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zym5xszc3: FaireProductEntity = {
  token: "p_6zym5xszc3",
  type: "product",
  name: "Ocean Air | Coastal Collection | 4 oz tin",
  brandName: "Keystone Inspired Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/4d421e7caa8864f13b4397873332fb6dea624236cbd42e367ce80a8d1e439824.jpeg",
  priceDollars: 7.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8f30cb91a2b736d2c227ab0a4de54eee89efd9fe5307acafed8f257f813b1ecc.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
